export const UPSTREAM = 'upstream';
export const LOCAL = 'local';
export const DOWNSTREAM = 'downstream';
export const DEFAULT = 'default';
export const BROWSER = 'browser';
export const ID = 'id';
export const CASCADE_CHAIN = [UPSTREAM, LOCAL, ID, DOWNSTREAM] as const;
export const CASCADE_CHAIN_BROWSER = [
  UPSTREAM,
  LOCAL,
  ID,
  DOWNSTREAM,
  BROWSER,
] as const;
